<template>
  <section>
    <!--工具条-->
    <el-col :span="6" class="toolbar">
      <el-input placeholder="卡券名称" size="small" v-model="query" @change="search">
        <el-button slot="append" icon="search" @click="search"></el-button></el-input>
    </el-col>

    <el-table :data="tableData"
              v-loading="listLoading">
      <el-table-column
        label="卡券名称"
        prop="couponname"
        align="center">
      </el-table-column>
      <el-table-column
        label="批次号"
        prop="couponstockid"
        align="center">
      </el-table-column>
      <el-table-column
        label="卡券金额"
        prop="couponvalue"
        align="center">
        <template scope="scope">
            <div>{{scope.row.couponvalue}}分</div>
        </template>
      </el-table-column>
      <el-table-column
        label="部分使用"
        prop="ispartialuse"
        align="center">
      </el-table-column>
      <el-table-column
        label="卡券ID"
        prop="couponid"
        align="center">
      </el-table-column>
      <el-table-column
        label="最小"
        prop="couponmininum"
        align="center">
      </el-table-column>
      <el-table-column
        label="已使用"
        prop="couponusevalue"
        align="center">
      </el-table-column>
      <el-table-column
        label="卡券剩余"
        prop="couponremainvalue"
        align="center">
      </el-table-column>
      <el-table-column
        label="创建时间"
        prop="createtime"
        align="center">
      </el-table-column>
    </el-table>

    <el-col :span="0" class="toolbar_page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 15, 20, 30]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </el-col>
  </section>
</template>

<script>
  import config from '../../config';

  export default {
    data() {
      return {
        tableData: [],
        total:0,
        page:1,
        pageSize:15,
        listLoading: false,
        query: '',
      }
    },
    methods: {
      //分页方法
      handleSizeChange(size) {
        this.pageSize = size;
        this.search();
      },
      handleCurrentChange(page) {
        this.page = page;
        this.search();
      },
      search() {
        this.getSearch(this.query);
      },
      getSearch(query) {
        this.listLoading = true;
        this.$axios.post(config.api_url + '/kaquan/record/page', {
          "page": this.page,
          "size": this.pageSize,
          "query": query
        }).then(response => {
          let data = response.data;
          if(data.state) {
            this.total = data.count;
            this.tableData = data.msg;
            this.listLoading = false;
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取数据异常，请联系管理员',
            type: 'error'
          });
        })
      },
    },
    created() {
      this.search();
    }
  }
</script>

<style scoped>
  .rightsearch{
    float: right;
  }
  .user-font {
    font-weight: 600;
    font-size: 15px;
    color: #48576a;
  }
</style>



// WEBPACK FOOTER //
// Record.vue?4a9e74a6